export default "__VITE_ASSET__DBaxxAVU__"